<template>
  <div class="dial-pad">
    <div v-if="!isCalling" class="number-grid">
      <div class="number-row">
        <div class="input-wrapper">
          <input
            type="text"
            v-model="inputValue"
            class="input-label"
            placeholder="请输入外呼号码"
            @keyup.enter="handleCall"
          />
        </div>
      </div>
      <div class="number-row">
        <div
          v-for="n in 3"
          :key="n"
          class="number-key"
          @click="appendNumber(n)"
        >
          <span class="number">{{ n }}</span>
        </div>
      </div>
      <div class="number-row">
        <div
          v-for="n in 3"
          :key="n + 3"
          class="number-key"
          @click="appendNumber(n + 3)"
        >
          <span class="number">{{ n + 3 }}</span>
        </div>
      </div>
      <div class="number-row">
        <div
          v-for="n in 3"
          :key="n + 6"
          class="number-key"
          @click="appendNumber(n + 6)"
        >
          <span class="number">{{ n + 6 }}</span>
        </div>
      </div>
      <div class="number-row">
        <div class="number-key">
          <span class="number">*</span>
        </div>
        <div class="number-key" @click="appendNumber('0')">
          <span class="number">0</span>
        </div>
        <div class="number-key" @click="deleteNumber">
          <span class="number">X</span>
        </div>
      </div>
      <div class="number-row">
        <div class="call-button" @click="handleCall">
          <img src="@/assets/images/phone.png" alt="call" />
        </div>
      </div>
    </div>

    <!-- 通话中状态 -->
    <div v-else class="calling-state">
      <div class="calling-info">
        <div class="phone-number">{{ inputValue }}</div>
        <div class="location">广州联通</div>
        <div class="status">{{ statusText }}</div>
      </div>

      <div class="control-btn" :class="{ active: isMuted }" @click="toggleMute">
        <i class="el-icon-microphone"></i>
        <span>{{ isMuted ? '已静音' : '静音' }}</span>
      </div>

      <div class="hangup" @click="handleHangup">
        <img src="@/assets/images/hangup.png" alt="hangup" />
      </div>
    </div>
    <!-- 音频元素 -->
    <audio ref="audio" autoplay></audio>
    <audio ref="busytone" src="@/assets/sounds/busytone.wav"></audio>
    <audio ref="ringbacktone" loop src="@/assets/sounds/ringbacktone.wav"></audio>
  </div>
</template>

<script>
import UCSIPCC from "@/utils/ucpaas-ipcc.js";
import { dateTimeFormatting } from "@/utils/format";
export default {
  name: "DialPad",
  props: {
    value: {
      type: String,
      default: "",
    },
    maxLength: {
      type: Number,
      default: 11,
    },
  },
  data() {
    return {
      inputValue: this.value,
      isCalling: false,
      isMuted: false,
      statusText: "正在拨号...",
      timer: {
        hour: 0,
        minute: 0,
        second: 0,
        timerId: null,
      },
      callInfo: {},
      dialRecord: {},
      userInfo: {},
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.inputValue = newVal;
      },
      immediate: true,
    },
    inputValue(newVal) {
      this.$emit("input", newVal);
    },
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    console.log("userInfo", this.userInfo);
    this.$root.$on('network-offline', this.handleNetworkOffline);
  },
  beforeDestroy() {
    this.$root.$off('network-offline', this.handleNetworkOffline);
  },
  methods: {
    appendNumber(num) {
      if (this.inputValue.length < this.maxLength) {
        this.inputValue += num;
      }
    },
    deleteNumber() {
      if (this.inputValue.length > 0) {
        this.inputValue = this.inputValue.slice(0, -1);
      }
    },
    async handleCall() {
      const calleeNumber = this.inputValue;
      const reg = /^\d{0,16}$/;
      if (!calleeNumber) {
        this.$message.error("请输入号码");
        return;
      }
      if (!reg.test(calleeNumber)) {
        this.$message.error("号码格式错误");
        return;
      }

      try {
        const response = await this.$http.post("/softCall", {
          callee: calleeNumber,
        });
        if (!response.data.result) {
          this.$message.error("获取呼叫前缀失败");
          return;
        }
        this.callInfo = response.data.data;
        this.callInfo.calleeNumber = calleeNumber;
        // 拼接前缀和手机号
        const fullNumber = response.data.data.callerPrefix + calleeNumber;
        console.log("calleeNumber", fullNumber);

        const options = {
          renderHint: {
            remote: this.$refs.audio,
            busytone: this.$refs.busytone,
          },
          requestId: Date.now().toString(),
          session_event: this.handleOutboundEvent,
        };

        UCSIPCC.createNewCall(fullNumber, options);

        this.isCalling = true;
        this.statusText = "正在拨号...";
      } catch (error) {
        console.error("获取呼叫前缀失败:", error);
        this.$message.error("获取呼叫前缀失败");
      }
    },

    async handleHangup() {
      await this.uploadCallStatus(2);
      await this.uploadCallRecord();
      UCSIPCC.hangupOutCall();
      this.isCalling = false;
      this.resetCallState();
    },

    async handleOutboundEvent(status_code, callid) {
      console.log("handleOutboundEvent", status_code, callid);
      switch (status_code) {
        case 1: // PROGRESS_CALL
          this.statusText = "呼叫中...";
          this.uploadCallStatus(1);
          break;
        case 8: // RING_CALL
          this.statusText = "振铃中...";
          this.$refs.ringbacktone.play();
          this.uploadCallStatus(3);
          break;
        case 2: // ANSWER_CALL
          this.startTimer();
          this.$refs.ringbacktone.pause();
          this.uploadCallStatus(4);
          this.currentSession = UCSIPCC.getOutSession();
          break;
        case 7: // CALL_FAILED
          this.statusText = "呼叫失败";
          this.$message.error('呼叫失败')
          this.$refs.ringbacktone.pause();
          // this.resetCallState();
          // this.uploadCallStatus(5);
          // this.currentSession = null;
          break;
        case 0: // CALL_ENDED
          // case 6: // BYE_CALL
          this.resetCallState();
          await this.uploadCallStatus(5);
          await this.uploadCallRecord();
          this.currentSession = null;
          break;
      }
    },

    async uploadCallStatus(callStatus) {
      if (callStatus == undefined) return;
      const statusTime = [
        "failTime",
        "beginTime",
        "endTime",
        "calleeRingTime",
        "calleeAnswerTime",
        "endTime",
      ];
      const status = statusTime[callStatus];
      this.dialRecord[status] =
        this.dialRecord[status] || dateTimeFormatting(new Date());
      const params = {
        caller: this.userInfo.phoneNumber,
        callId: this.callInfo.callId,
        callee: this.callInfo.calleeNumber,
        callStatus,
        eventTime: dateTimeFormatting(new Date()),
      };
      console.log(status + "---" + this.dialRecord[status]);
      await this.$http.post("/callback/callStatus", params, function (res) {
        console.log(res);
      });
    },
    async uploadCallRecord() {
      if (!this.dialRecord.beginTime) return;
      const endTime = this.dialRecord.endTime || dateTimeFormatting(new Date());
      const params = {
        caller: this.userInfo.phoneNumber,
        callId: this.callInfo.callId,
        callee: this.callInfo.calleeNumber,
        ...this.dialRecord,
        endTime,
      };
      console.log(`上报记录：${JSON.stringify(params)}`);
      if (params.beginTime === params.endTime) {
        this.$message.error("线路异常，请联系客服！");
      }
      this.dialRecord = {};

      await this.$http.post("/callback/finish", params, function (res) {
        console.log(res);
      });
      // 帮我写入到本地缓存中，以手机号为key,记录为数组
      const records = JSON.parse(localStorage.getItem(this.userInfo.phoneNumber) || '[]');
      records.unshift(params); // 在数组开头添加新记录
      // 只保留最新的10条记录
      const latestRecords = records.slice(0, 10);
      localStorage.setItem(this.userInfo.phoneNumber, JSON.stringify(latestRecords));
      setTimeout(() => {
        this.$emit("queryCallRecords");
      }, 300);
    },

    getCallInfo() {
      const session = UCSIPCC.getOutSession();
      if (!session) return null;
      
      return {
        startTime: session.startTime ? new Date(session.startTime) : null,
        duration: session.startTime ? Math.floor((Date.now() - session.startTime) / 1000) : 0,
        remoteNumber: session.remoteIdentity?.uri?.user || this.inputValue,
        status: this.statusText,
        isMuted: this.isMuted,
        isConnected: !!session.startTime
      };
    },

    // handleIncomingCall(incall) {
    //   const session = {
    //     uri: incall.uri,
    //     displayName: incall.displayName,
    //     status: '正在呼入...',
    //     acceptDisabled: false,
    //     rejectDisabled: false,
    //     rejectButtonText: '拒绝',
    //     hideAccept: false,
    //     showClose: false,
    //     session: incall.session
    //   }

    //   this.sessions.push(session)
    //   this.startRingTone(session)

    //   const options = {
    //     renderHint: {
    //       remote: this.$refs[`audio-${session.uri}`][0],
    //       busytone: document.getElementById('busytone')
    //     },
    //     session_event: (status_code) => this.handleInboundEvent(status_code, session)
    //   }

    //   UCSIPCC.configInbound(incall, options)
    // },

    // handleAccept(session) {
    //   session.status = '已接听...'
    //   session.acceptDisabled = true
    //   session.rejectButtonText = '挂机'
    //   session.hideAccept = true
    //   this.stopRingTone(session)
    //   UCSIPCC.acceptCall(session)
    // },

    // handleReject(session) {
    //   session.status = '正在挂机...'
    //   UCSIPCC.hangupInCall(session)
    //   this.stopRingTone(session)
    // },

    // closeSession(session) {
    //   const index = this.sessions.findIndex(s => s.uri === session.uri)
    //   if (index > -1) {
    //     this.sessions.splice(index, 1)
    //   }
    // },

    // handleInboundEvent(status_code, session) {
    //   switch (status_code) {
    //     case 7: // CALL_FAILED
    //       session.status = '呼叫结束'
    //       session.acceptDisabled = true
    //       session.rejectDisabled = true
    //       this.stopRingTone(session)
    //       break
    //     case 0: // CALL_ENDED
    //       session.hideAccept = true
    //       session.showClose = true
    //       break
    //     case 6: // BYE_CALL
    //       session.status = '通话结束'
    //       session.rejectDisabled = true
    //       break
    //     case 2: // ANSWER_CALL
    //       session.status = '通话中...'
    //       this.stopRingTone(session)
    //       break
    //   }
    // },

    // startRingTone(session) {
    //   try {
    //     const ringtone = this.$refs[`ringtone-${session.uri}`][0]
    //     if (ringtone) ringtone.play()
    //   } catch (e) {
    //     console.error('播放铃声失败:', e)
    //   }
    // },

    // stopRingTone(session) {
    //   try {
    //     const ringtone = this.$refs[`ringtone-${session.uri}`][0]
    //     if (ringtone) ringtone.pause()
    //   } catch (e) {
    //     console.error('停止铃声失败:', e)
    //   }
    // },

    startTimer() {
      this.statusText = "通话中：0:0:0";
      this.timer.timerId = setInterval(() => {
        if (this.timer.second === 59) {
          this.timer.minute++;
          this.timer.second = 0;
          if (this.timer.minute === 59) {
            this.timer.hour++;
            this.timer.minute = 0;
          }
        } else {
          this.timer.second++;
        }
        this.statusText = `通话中：${this.timer.hour}:${this.timer.minute}:${this.timer.second}`;
      }, 1000);
    },

    resetCallState() {
      this.isCalling = false;
      this.inputValue = "";
      this.statusText = "";
      this.isMuted = false;
      if (this.timer.timerId) {
        clearInterval(this.timer.timerId);
        this.timer.hour = 0;
        this.timer.minute = 0;
        this.timer.second = 0;
      }
    },

    toggleMute() {
      console.log("toggleMute", this.currentSession, this.isMuted);
      if (this.currentSession) {
        if (!this.isMuted) {
          UCSIPCC.mute(this.currentSession);
        } else {
          UCSIPCC.unmute(this.currentSession);
        }
        this.isMuted = !this.isMuted;
      }
    },
    handleNetworkOffline() {
      if (this.isCalling) {
        this.handleHangup();
        this.$message.error('网络断开，通话已结束');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.dial-pad {
  width: 400px;
  max-width: 375px;
  background: #fff;
  border-radius: 24px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.input-wrapper {
  width: 100%;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.input-label {
  width: 100%;
  font-size: 24px;
  color: #2b4b75;
  font-weight: 500;
  background: transparent;
  border: none;
  outline: none;
  text-align: center;
  padding: 20px 0;
  // caret-color: transparent;
  cursor: default;

  &::placeholder {
    color: #2b4b75;
    opacity: 0.8;
  }
}

.number-grid {
  width: 100%;

  .number-row {
    display: flex;
    justify-content: center;
    height: 80px;
    background: linear-gradient(180deg, #ffffff 0%, #f1f5ff 100%);

    &:first-child {
      background: #fff;
    }
  }
}

.number-key {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  overflow: hidden;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100px;
    height: 100px;
    background: rgba(85, 121, 231, 0.1);
    border-radius: 50%;
    transform: translate(-50%, -50%) scale(0);
    transition: transform 0.3s ease-out;
  }

  &:active::before {
    transform: translate(-50%, -50%) scale(1);
  }

  &:hover {
    background: rgba(85, 121, 231, 0.05);
  }

  .number {
    font-size: 24px;
    font-weight: 500;
    color: #5579e7;
    position: relative;
    z-index: 1;
  }
}

.call-button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  img {
    width: 60px;
    height: 60px;
  }
}

/* 通话中状态样式 */
.calling-state {
  width: 100%;
  height: 480px;
  background: linear-gradient(135deg, #5579e7 0%, #7b94ec 100%);
  border-radius: 24px;
  padding: 40px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: white;

  .calling-info {
    text-align: center;

    .phone-number {
      font-size: 32px;
      font-weight: 500;
      margin-bottom: 24px;
    }

    .location {
      font-size: 16px;
      opacity: 0.8;
      margin-bottom: 16px;
    }

    .status {
      font-size: 14px;
      opacity: 0.6;
    }
  }

  .control-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    margin-top: 80px;
    padding: 12px;
    border-radius: 12px;
    transition: all 0.3s;

    i {
      font-size: 28px;
    }

    span {
      font-size: 20px;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }

    &.active {
      background: rgba(255, 255, 255, 0.2);
    }
  }
  .hangup {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    img {
      width: 60px;
      height: 60px;
      cursor: pointer;
    }
  }
}
</style>
